<template>
  <!-- ontouchstart allows to use :active pseudo class on safari mobile -->
  <button
    type="button"
    class="arrow-button active:text-br-green focus-visible:outline-offset-2 focus-visible:outline-2"
    :class="{
      'pointer-events-none opacity-10 hover:text-black': arrowDisabled,
      'lg:hover:text-br-green': !arrowDisabled && !inverted,
      'text-white focus-visible:outline-white': !arrowDisabled && inverted,
    }"
    :disabled="arrowDisabled"
    @touchstart.passive="doNothing"
    @click.prevent="$emit('click', direction)"
    :aria-label="direction === 'left' ? $t('common.previous') : $t('common.next')"
  >
    <ArrowIcon class="h-5 transition-all" :class="direction === 'right' ? 'rotate-180' : null" />
  </button>
</template>

<script>
import ArrowIcon from '@/components/icons/ArrowIcon';

export default defineNuxtComponent({
  components: { ArrowIcon },
  emits: ['click'],
  props: {
    arrowDisabled: {
      type: Boolean,
      default: false,
    },
    inverted: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String,
      default: 'left',
    },
  },
  methods: {
    doNothing() {},
  },
});
</script>

<style>
@reference "~/assets/css/main.css";
@media (hover: hover) and (pointer: fine) {
  .arrow-button:hover {
    @apply text-br-green; /* solves sticky problem */
  }
}
</style>
